var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M20.5 1.5a2 2 0 0 1 2 2v17a2 2 0 0 1-2 2h-17a2 2 0 0 1-2-2v-17a2 2 0 0 1 2-2zm0 2h-17v17h17zM16 11a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }